import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { API_URL, VPS_URL } from "../../configurations/server-config";
import { timeout } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class PassagerService {
  private API = "http://169.58.185.13:8800";
  private VPS = VPS_URL;

  constructor(private http: HttpClient) {}

  savepassagerVoyage(type: any): any {
    return this.http.post(`${API_URL}/passagervoyage`, type, {
      observe: "response",
    });
  }

  updatepassagerVoyage(type: any): any {
    return this.http.put(`${API_URL}/passagervoyage`, type, {
      observe: "response",
    });
  }

  getAllPassagerVoyage(
    page = 0,
    size = 10,
    sortby: any = null,
    orderby: any = null,
  ): any {
    return this.http.get(
      `${API_URL}/passagervoyage?page=${page}&size=${size}&sortby=${sortby}&direction=${orderby}`,
    );
  }

  deletePassagerVoyage(id: any): any {
    return this.http.delete(`${API_URL}/passagervoyage/${id}`);
  }

  getPassagerVoyagelist(): any {
    return this.http.get(`${API_URL}/passagervoyagelist`);
  }

  getallticketinSession(session: any, page: any, size: any): any {
    return this.http.get(
      `${API_URL}/passagerinsessions?sid=${session}&page=${page}&size=${size}`,
    );
  }

  getPassagerticketdetail(id: any): any {
    return this.http.get(`${API_URL}/getpassagerticketbyid?id=${id}`);
  }

  checkplaceavailability(id: any, place: any): any {
    return this.http.get(`${API_URL}/checkplaceavailable?id=${id}&pl=${place}`);
  }

  cancelticket(passager: any): any {
    return this.http.post(`${API_URL}/cancelticket`, passager);
  }

  searchByticket(name: string): any {
    return this.http.post(
      `${API_URL}/passagervoyage/searchticket?q=${name}`,
      null,
    );
  }

  searchByNom(name: string): any {
    return this.http.post(
      `${API_URL}/passagervoyage/searchnom?q=${name}`,
      null,
    );
  }

  searchByContact(name: string): any {
    return this.http.post(
      `${API_URL}/passagervoyage/searchcontact?q=${name}`,
      null,
    );
  }

  searchByPrix(name: any): any {
    return this.http.post(
      `${API_URL}/passagervoyage/searchbyprix?q=${name}`,
      null,
    );
  }

  getpassengerTripListWithPhoneAndName(name: any, contact: any): any {
    return this.http.post(
      `${this.API}/passagervoyage/searchnomandcontact?n=${name}&p=${contact}`,
      null,
    );
  }

  // passenger list
  getAllPassagerList(page = 0, size = 10): any {
    return this.http.get(`${this.API}/passengerlist?page=${page}&size=${size}`);
  }

  getPassagerTripList(
    passengerid: any,
    page = 0,
    size = 10,
    sortby: any = null,
    orderby: any = null,
  ): any {
    return this.http.get(
      `${this.API}/passengertrip?page=${page}&size=${size}&id=${passengerid}&sortby=${sortby}&direction=${orderby}`,
    );
  }

  transferpassenger(idvoyage: any, oldvoayge: any, idpassager: any): any {
    return this.http.post(
      `${API_URL}/transferpassenger?id=${idpassager}&oid=${oldvoayge}&vid=${idvoyage}`,
      null,
    );
  }

  transferPassengersBatch(data: {
    oldvoyageid: string;
    newvoyageid: string;
    passengerids: string[];
  }): any {
    return this.http.post(`${API_URL}/transferpassengers`, data);
  }

  searchpassenger(name: string): any {
    return this.http.post(`${this.API}/passager/search?q=${name}`, null);
  }

  convertTicket(data: any): any {
    return this.http.post(`${API_URL}/convertticket`, data);
  }

  transfertTicket(data: any): any {
    return this.http.post(`${API_URL}/transferticket`, data);
  }

  // Search passenger tickets for validation (VPS only).
  searchPassengerTickets(query: string, agencyCode: string): any {
    return this.http.post(`${this.VPS}/passagervoyage/search?q=${query}`, null);
  }

  // Validate selected passenger tickets on central VPS.
  validatePassengerTickets(ticketIds: string[], agencyCode: string): any {
    return this.http.post(`${this.VPS}/passagervoyage/validate`, ticketIds, {
      headers: { "Content-Type": "application/json" },
    });
  }

  searchAdvancedTickets(criteria: any): any {
    return this.http.post(
      `${this.VPS}/passagervoyage/search-advanced`,
      criteria,
      {
        headers: { "Content-Type": "application/json" },
      },
    );
  }

  compensatePassenger(payload: any): any {
    return this.http.post(`${this.VPS}/passagervoyage/compensate`, payload, {
      headers: { "Content-Type": "application/json" },
    });
  }

  pingVPS(): any {
    return this.http
      .get(`${this.VPS}/health`, { observe: "response" })
      .pipe(timeout(4000));
  }

  updateTicketStatusAfterCount(Idpassager: any, freecode: any): any {
    return this.http.post(
      `${this.VPS}/updateTicketStatusAfterCount?id=${Idpassager}&code=${freecode}`,
      null,
    );
  }

  getCriteriaSearch(
    criteria: any,
    page = 0,
    size = 10,
    sort = "creationdate",
    direction = "asc",
  ): any {
    let params = new HttpParams()
      .set("page", page.toString())
      .set("size", size.toString())
      .set("sort", sort)
      .set("direction", direction);

    Object.keys(criteria).forEach((key) => {
      if (
        criteria[key] !== null &&
        criteria[key] !== undefined &&
        criteria[key] !== ""
      ) {
        params = params.set(key, criteria[key]);
      }
    });

    return this.http.get(`${API_URL}/passager/criteria`, { params });
  }
}
